export default __webpack_public_path__ + "static/media/13.fed4c4ce.jpg";